/* eslint-disable camelcase */
import type { ServiceResourcesDto } from './dto';
import type { ServiceResources } from './model';

export const mapServiceResourcesDtoToModel = (
  { organizations, sites }: ServiceResourcesDto,
  accountOwnerId?: number,
): ServiceResources => {
  const sort = (a: { name: string }, b: { name: string }) =>
    a.name.localeCompare(b.name, 'en', { sensitivity: 'base' });

  return organizations
    .map((organization) => ({
      id: organization.id,
      name: organization.name,
      sites: sites
        .filter(({ organization_id }) => organization_id === organization.id)
        .filter((site) =>
          accountOwnerId === undefined ? true : site.account.id === accountOwnerId,
        )
        .map((site) => ({
          id: String(site.id),
          name: site.name,
          url: site.url,
          isTwoSkusActionRequired: site.is_two_skus_action_required,
        }))
        .sort(sort),
    }))
    .filter((organization) => !!organization.sites.length)
    .sort(sort);
};
